export default class DynamicArea {
	constructor(element) {
		this.area = element;
		this.pagination = this.area.querySelector('[data-dynamic-area-pagination]');
		this.content = this.area.querySelector('[data-dynamic-area-content]');
		this.form = this.area.querySelector('[data-dynamic-area-form]');
		this.icon = this.area.querySelector('[data-dynamic-area-icon-spinner]');
		this.debounce = null;

		this.attach();
	}

	attach() {
		this.form.addEventListener('submit', this.submit.bind(this));
		this.form.addEventListener('change', this.delegateChange.bind(this));
		this.form.addEventListener('input', this.delegateChange.bind(this));
		this.pagination.addEventListener('click', this.onLinkClick.bind(this));
	}

	debounceSubmit(event) {
		clearTimeout(this.debounce);

		this.debounce = setTimeout(() => this.submit(event), 250);
	}

	delegateChange(event) {
		const el = event.target;

		if (el.tagName === 'SELECT') {
			this.submit(event);

			return;
		}

		if (el.tagName !== 'INPUT') {
			return;
		}

		if (['checkbox', 'radio'].includes(el.type)) {
			this.submit(event);
		} else {
			this.debounceSubmit(event);
		}
	}

	onLinkClick(event) {
		const el = event.target.closest('a');

		if (!el) {
			return;
		}

		event.preventDefault();

		this.area.scrollIntoView({ behavior: 'smooth' });

		this.send(el.href);
	}

	replaceContent(html, url) {
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');
		const content = doc.querySelector('[data-dynamic-area-content]');
		const pagination = doc.querySelector('[data-dynamic-area-pagination]');

		this.content.innerHTML = content.innerHTML;
		this.pagination.innerHTML = pagination.innerHTML;

		window.history.pushState({}, doc.title, url);
	}

	submit(event) {
		clearTimeout(this.debounce);

		event.preventDefault();

		const formData = new FormData(this.form);
		const params = new URLSearchParams(formData);

		this.send(`${this.form.action}?${params}`);
	}

	send(url) {
		this.startLoading();

		fetch(url)
			.then((response) => response.text())
			.then((html) => this.replaceContent(html, url))
			.finally(() => this.stopLoading());
	}

	startLoading() {
		const el = this.icon.querySelector('use');

		if (!el.hasAttribute('data-original-icon')) {
			el.setAttribute('data-original-icon', el.getAttribute('xlink:href'));
		}

		el.setAttribute('xlink:href', '#icon-spinner');
	}

	stopLoading() {
		const el = this.icon.querySelector('use');

		el.setAttribute('xlink:href', el.getAttribute('data-original-icon'));
	}
}
